var React = require('react');

function GarageInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.273 9.73v17.54h27.869V9.73l1.443.721.83-1.662L16.208.686 0 8.789l.83 1.662 1.443-.721zm22.295 15.683H7.848v-1.858h16.72v1.858zm0-3.716H7.848v-1.858h16.72v1.858zm0-3.716H7.848v-1.858h16.72v1.858zm0-3.716H7.848v-1.858h16.72v1.858zM4.131 8.801l12.077-6.038L28.284 8.8v16.612h-1.858V10.549H5.99v14.864H4.131V8.8z","fill":"currentColor","fillRule":"nonzero"}));
}

GarageInline.defaultProps = {"viewBox":"0 0 35 30","width":"33","height":"28"};

module.exports = GarageInline;

GarageInline.default = GarageInline;
